export default "__VITE_ASSET__51Ulvj2k__"